module.exports = __webpack_public_path__ + "img/banner01.92f260c5.png";